import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GeoLocationService {
  getCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }
}